import React from 'react';
import styles from './Header.module.scss';
import { GlobalHeader, GlobalHeaderProps } from '@eventbrite/consumer-header.global-header';
import { useAppContext } from '@/components/_shared/context/AppContext';

interface HeaderProps {
  globalHeaderProps?: GlobalHeaderProps;
}

class HeaderErrorBoundary extends React.Component<{ children: React.ReactNode }, { hasError: boolean }> {
  state = { hasError: false };

  static getDerivedStateFromError() {
    return { hasError: true };
  }

  componentDidCatch(error: Error) {
    console.error('Header render error caught by boundary:', error);
  }

  render() {
    if (this.state.hasError) {
      return (
        <div className={styles.wrapper} data-testid="header">
          <div className={styles.content} />
        </div>
      );
    }
    return this.props.children;
  }
}

export const Header: React.FC<HeaderProps> = ({ globalHeaderProps }) => {
  const { data } = useAppContext();

  return (
    <HeaderErrorBoundary>
      <div className={styles.wrapper} data-testid="header">
        <div className={styles.content}>
          <GlobalHeader
            env={{
              ...globalHeaderProps?.env,
              serverUrl: data.serverUrl,
            }}
            request={{ path: '/e/' }}
            isHomePage={false}
            disableFetchUser={false}
          />
        </div>
      </div>
    </HeaderErrorBoundary>
  );
};
